import React from 'react';
import { 
    FiX, FiUploadCloud, FiFileText, FiImage, 
    FiTrash2, FiDownload, FiPlus 
} from 'react-icons/fi';
import styles from './VehicleFilesPopup.module.css';

const VehicleFilesPopup = ({ vehicle, onClose }) => {
    const mockFiles = [
        { id: 1, name: 'CRLV_2024.pdf', size: '245 KB', type: 'pdf', date: '10/01/2026' },
        { id: 2, name: 'vistoria_frontal.jpg', size: '1.2 MB', type: 'image', date: '12/01/2026' },
        { id: 3, name: 'comprovante_aet.pdf', size: '150 KB', type: 'pdf', date: '15/01/2026' },
    ];

    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.header}>
                    <div>
                        <h2>Arquivos do Veículo</h2>
                        <p>{vehicle?.marca} {vehicle?.modelo} - {vehicle?.placa}</p>
                    </div>
                    <button className={styles.closeBtn} onClick={onClose}>
                        <FiX />
                    </button>
                </div>

                <div className={styles.body}>
                    <div className={styles.uploadSection}>
                        <div className={styles.dropzone}>
                            <FiUploadCloud className={styles.uploadIcon} />
                            <p>Arraste arquivos ou <span>clique aqui</span></p>
                            <small>PDF, PNG, JPG (Máx. 10MB)</small>
                        </div>
                    </div>

                    <div className={styles.fileListSection}>
                        <div className={styles.listHeader}>
                            <h3>Arquivos Salvos ({mockFiles.length})</h3>
                            <button className={styles.addBtn}>
                                <FiPlus /> Adicionar Novo
                            </button>
                        </div>

                        <div className={styles.grid}>
                            {mockFiles.map(file => (
                                <div key={file.id} className={styles.fileCard}>
                                    <div className={styles.fileIcon}>
                                        {file.type === 'pdf' ? <FiFileText /> : <FiImage />}
                                    </div>
                                    <div className={styles.fileInfo}>
                                        <span className={styles.fileName}>{file.name}</span>
                                        <span className={styles.fileMeta}>{file.date} • {file.size}</span>
                                    </div>
                                    <div className={styles.fileActions}>
                                        <button title="Baixar"><FiDownload /></button>
                                        <button title="Excluir" className={styles.deleteBtn}><FiTrash2 /></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button className={styles.secondaryBtn} onClick={onClose}>Fechar</button>
                </div>
            </div>
        </div>
    );
};

export default VehicleFilesPopup;